import React from 'react'
import { IonCol, IonLabel, IonRow, IonText } from '@ionic/react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getSpecialReportsSelector } from '../selectors'
import { STEP_IDS } from '../constants'
import './specialReports.page.css'

const SpecialReportHeaderInfo: React.FC = () => {
  const { t } = useTranslation()
  const specialReportsState = useSelector(getSpecialReportsSelector)
  const { categories, subCategories, subject, __currentStep } = specialReportsState

  const selectedCategoryName = categories.length > 0 ? categories[0]?.name || '' : ''

  const selectedSubCategoryNames = subCategories
    .map((sub) => sub.name || '')
    .filter(Boolean)
    .join(', ')

  const isDetailsStep = __currentStep === STEP_IDS.DETAILS
  const hasSubject = subject && subject.trim() !== ''

  return (
    <IonRow>
      <IonCol size='12'>
        <IonLabel>
          {hasSubject && (
            <IonLabel color='medium' className='auto-emails-label mt-1'>
              {subject}
            </IonLabel>
          )}
        </IonLabel>
      </IonCol>

      {!isDetailsStep ? (
        <IonCol size='12' className=''>
          <IonRow>
            <IonCol size='3'>
              <IonLabel>{t('specialReports.type')}:</IonLabel>
            </IonCol>
            <IonCol size='9'>
              <IonLabel color='medium'>{selectedCategoryName}</IonLabel>
            </IonCol>
            <IonCol size='3'>
              <IonLabel>{t('specialReports.subType')}:</IonLabel>
            </IonCol>
            <IonCol size='9'>
              <IonLabel color='medium' className='subcategory-names-ellipsis'>
                {selectedSubCategoryNames}
              </IonLabel>
            </IonCol>
          </IonRow>
        </IonCol>
      ) : (
        <IonCol size='12'>
          <IonText className='font-weight-bold' color='medium'>
            {t('specialReports.reportType')}
          </IonText>
        </IonCol>
      )}
    </IonRow>
  )
}

export default SpecialReportHeaderInfo
